import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { useIntl } from "../../lib/i18n";
import LanguageSwitcher from "../../components/LanguageSwitcher";

type NavItem = { to: string; key: string };

const NAV: NavItem[] = [
  { to: "/admin", key: "nav.dashboard" },
  { to: "/admin/inbox", key: "nav.inbox" },
  { to: "/admin/matters", key: "nav.matters" },
  { to: "/admin/attorneys", key: "nav.attorneys" },
  { to: "/admin/bookings", key: "nav.bookings" },
  { to: "/admin/drafts", key: "nav.drafts" },
  { to: "/admin/deadlines", key: "nav.deadlines" },
  { to: "/admin/intakes/active", key: "nav.intakes" },
  { to: "/admin/conflict-check", key: "nav.conflict_check" },
  { to: "/admin/sms", key: "nav.sms" },
  { to: "/admin/reviews", key: "nav.reviews" },
  { to: "/admin/site", key: "nav.site" },
  { to: "/admin/site-builder", key: "nav.site_builder" },
  { to: "/admin/theme", key: "nav.theme" },
  { to: "/admin/sections", key: "nav.sections" },
  { to: "/admin/integrations", key: "nav.integrations" },
  { to: "/admin/iolta", key: "nav.iolta" },
  { to: "/admin/registry", key: "nav.registry" },
  { to: "/admin/playbooks", key: "nav.playbooks" },
  { to: "/admin/ai-activation", key: "nav.ai_activation" },
  { to: "/admin/ai-costs", key: "nav.ai_costs" },
  { to: "/admin/audit", key: "nav.audit" },
  { to: "/admin/platform", key: "nav.platform" },
  { to: "/admin/profile", key: "nav.profile" },
];

export default function AdminLayout() {
  const { session, logout } = useAuth();
  const { t } = useIntl();
  const navigate = useNavigate();
  const onLogout = () => {
    logout();
    navigate("/login");
  };
  return (
    <div className="grid h-full grid-cols-[16rem_1fr]">
      <aside className="flex h-full flex-col border-r border-slate-200 bg-brand-900 text-slate-100">
        <div className="px-6 py-5">
          <span className="text-lg font-semibold">{t("app.title")}</span>
        </div>
        <nav className="flex-1 space-y-1 overflow-y-auto px-3 pb-3">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/admin"}
              className={({ isActive }) =>
                [
                  "block rounded-md px-3 py-2 text-sm",
                  isActive ? "bg-brand-700 text-white" : "text-slate-300 hover:bg-brand-700/60",
                ].join(" ")
              }
            >
              {t(n.key)}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-2 border-t border-brand-700/60 p-3 text-sm">
          <div className="px-3 text-slate-300">{session?.email}</div>
          <div className="flex items-center justify-between px-3">
            <LanguageSwitcher />
            <button
              type="button"
              onClick={onLogout}
              className="rounded-md bg-brand-700 px-3 py-1 text-xs text-white hover:bg-brand-500"
            >
              {t("nav.logout")}
            </button>
          </div>
        </div>
      </aside>
      <main className="overflow-auto bg-slate-50">
        <div className="mx-auto max-w-6xl px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
